import {
  CircularProgress,
  Divider,
  Paper,
  useMediaQuery,
} from "@material-ui/core";
import useStyles from "../style";
import getSessionStorage from "utils/getSessionStorage";

type Props = {
  hiraCountObject: any;
  isLoadingHiraCount: any;
  activeTab?: any;
  setActiveTab?: any;
};

const HiraCountSection = ({
  hiraCountObject,
  isLoadingHiraCount,
  activeTab = 0,
  setActiveTab,
}: Props) => {
  const matches = useMediaQuery("(min-width:820px)");
  const smallScreen = useMediaQuery("(min-width:470px)");
  const classes = useStyles(matches)();
  const userDetails = getSessionStorage();
  // const [activeTab, setActiveTab] = useState<any>(0);

  const handleTabClick = (index: any) => {
    setActiveTab(index);
  };

  return (
    <>
      {isLoadingHiraCount ? (
        <CircularProgress />
      ) : (
        <div className={classes.parentDiv}>
          {/* Total HIRA tab 0,1 */}
          <div className={classes.papermaincontain}>
            <p className={classes.headingText}>
              Total HIRA
              <span
                style={{
                  fontSize: "10px", // Tiny font size
                  color: "#737373", // Subtle gray color
                  marginLeft: "5px", // Small spacing from the main text
                  display: "inline-block", // Ensures it aligns properly
                }}
              >
                (approved)
              </span>
            </p>

            <Paper elevation={0} className={classes.paper}>
              <div
                className={`${classes.papercontainers}`}
                style={{ color: "inherit", cursor: "default" }} // Default style, no blue background
              >
                <span className={classes.headingnumber1}>
                  {hiraCountObject?.totalEntityWise}
                </span>
                <span
                  className={classes.headingname}
                  style={{ borderColor: "black", color: "#737373" }}
                >
                  My Dept
                </span>
              </div>
              <Divider
                orientation="vertical"
                flexItem
                className={classes.divider}
              />
              <div
                className={`${classes.papercontainers}`}
                style={{ color: "inherit", cursor: "default" }} // Default style, no blue background
              >
                <span className={classes.headingnumber}>
                  {hiraCountObject?.totalLocationWise}
                </span>
                <span
                  className={classes.headingname}
                  style={{ borderColor: "black", color: "#737373" }}
                >
                  My Unit
                </span>
              </div>
            </Paper>
          </div>

          {/* InWorkflow HIRA tab 4,5 */}
          <div className={classes.papermaincontain}>
            <p className={classes.headingText}>InWorkflow HIRA</p>
            <Paper elevation={0} className={classes.paper}>
              <div
                className={`${classes.papercontainers}`}
                style={{ color: "inherit", cursor: "default" }}
              >
                <span className={classes.headingnumber1}>
                  {hiraCountObject?.inWorkflowEntityWise}
                </span>
                <span
                  className={classes.headingname}
                  style={{ borderColor: "black", color: "#737373" }}
                >
                  My Dept
                </span>
              </div>
              <Divider
                orientation="vertical"
                flexItem
                className={classes.divider}
              />
              <div
                className={`${classes.papercontainers}`}
                style={{ color: "inherit", cursor: "default" }}
              >
                <span className={classes.headingnumber}>
                  {hiraCountObject?.inWorkflowLocationWise}
                </span>
                <span
                  className={classes.headingname}
                  style={{ borderColor: "black", color: "#737373" }}
                >
                  My Unit
                </span>
              </div>
            </Paper>
          </div>

          {/* Current Year HIRA tab 2,3 */}
          <div className={classes.papermaincontain}>
            <p className={classes.headingText}>Current Year HIRA</p>
            <Paper elevation={0} className={classes.paper}>
              <div
                className={`${classes.papercontainers}`}
                style={{ color: "inherit", cursor: "default" }}
              >
                <span className={classes.headingnumber1}>
                  {hiraCountObject?.totalCurrentYearEntityWise}
                </span>
                <span
                  className={classes.headingname}
                  style={{ borderColor: "black", color: "#737373" }}
                >
                  My Dept
                </span>
              </div>
              <Divider
                orientation="vertical"
                flexItem
                className={classes.divider}
              />
              <div
                className={`${classes.papercontainers}`}
                style={{ color: "inherit", cursor: "default" }}
              >
                <span className={classes.headingnumber}>
                  {hiraCountObject?.totalCurrentYearLocationWise}
                </span>
                <span
                  className={classes.headingname}
                  style={{ borderColor: "black", color: "#737373" }}
                >
                  My Unit
                </span>
              </div>
            </Paper>
          </div>

          {/* Significant Steps tab 6,7 */}
          <div className={classes.papermaincontain}>
            <p className={classes.headingText}>Significant Steps</p>
            <Paper elevation={0} className={classes.paper}>
              <div
                className={`${classes.papercontainers}`}
                style={{ color: "inherit", cursor: "default" }}
              >
                <span className={classes.headingnumber1}>
                  {hiraCountObject?.totalSignificantStepsEntityWise}
                </span>
                <span
                  className={classes.headingname}
                  style={{ borderColor: "black", color: "#737373" }}
                >
                  My Dept
                </span>
              </div>
              <Divider
                orientation="vertical"
                flexItem
                className={classes.divider}
              />
              <div
                className={`${classes.papercontainers}`}
                style={{ color: "inherit", cursor: "default" }}
              >
                <span className={classes.headingnumber}>
                  {hiraCountObject?.totalSignificantStepsLocationWise}
                </span>
                <span
                  className={classes.headingname}
                  style={{ borderColor: "black", color: "#737373" }}
                >
                  My Unit
                </span>
              </div>
            </Paper>
          </div>
        </div>
      )}
    </>
  );
};

export default HiraCountSection;
